import React, { useState } from 'react';
import { Form, TimePicker, message, InputNumber, Button } from 'antd';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';

const layout = {
	labelCol: {
		span: 10,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 10,
		span: 16,
	},
};

const CalenderEditForm = ({ fetchCalender, calender, updateCalender, closeModal }) => {
	const [editTime, setTime] = useState();

	const mystyle = {
		display: 'flex',
		flexDirection: 'column',
		padding: '10px',
	};

	const onFinish = async (values) => {
		let body;
		if (editTime && editTime.length > 0) {
			body = { slot: values?.slot, startTime: editTime[0]._d, endTime: editTime[1]._d };
		} else body = { slot: values?.slot };
		await updateCalender(calender._id, body);
		fetchCalender();
		closeModal();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<Form
			{...layout}
			name="calenderForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item
				initialValue={calender?.slot}
				label="Slot"
				name={['slot']}
				rules={InputRules.required('Please enter slot time in mins!')}
			>
				<InputNumber placeholder="Enter Slot in mins" />
			</Form.Item>
			<div style={mystyle}>
				<TimePicker.RangePicker
					style={{ padding: '20' }}
					onOk={(value) => {
						setTime(value);
					}}
				/>
			</div>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Update Order
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => ({
	fetchCalender: () => dispatch(Actions.fetchCalender()),
	updateCalender: (id, body) => dispatch(Actions.updateCalender(id, body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalenderEditForm);
